<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('rooms_need_cleaning')"  :is-filter="false" >
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('rooms_need_cleaning')" :is-filter="false"> >
				</HeaderMobile>
			</template>
			<datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
				:total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
				@on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
			</datatable>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import Datatable from "@/components/datatable/Datatable";




// Others
import RoomsNeedCleaning from "@/services/RoomsNeedCleaning";

export default {
	components: {
		AppLayout,
		Header,
		HeaderMobile,
		Datatable,

	},
	metaInfo() {
		return {
			title: this.$t('rooms_need_cleaning')
		}
	},
	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: this.toUpperCase('building'),
						field: 'housing_bed.room.building.name',
						hidden: false,
					},
					{
						label: this.toUpperCase('floor'),
						field: 'housing_bed.room.floor',
						hidden: false,
					},
					{
						label: this.toUpperCase('room'),
						field: 'housing_bed.room.name',
						hidden: false,
					},
					{
						label: this.toUpperCase('bed'),
						field: 'housing_bed.name',
					},
          {
              label: this.toUpperCase('date'),
              field: 'cleaning_date'
          },
				],
				rows: [],
				total: 0,
				filterStatus: true,
				showTable: true,
				queryParams: {
					filter: {},
					sort: 'id',
					page: 1,
					limit: 20
				}
			},
			formProcess: null,
			formId: null,
			form: {},
		}
	},
	created() {
        this.getRows()
	},
	methods: {
		filter() {
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		onPageChange(params) {
			this.datatable.queryParams.page = params.currentPage;
			this.getRows();
		},
		onPerPageChange(params) {
			this.datatable.queryParams.limit = params.currentPerPage;
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		changeColumn(key) {
			this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
		},
		onSortChange(params) {
			const sortType = params[0].type == 'desc' ? '-' : '';
			this.datatable.queryParams.sort = sortType + params[0].field
			this.getRows();
		},
		getRows() {
			this.datatable.showTable = true;
			this.datatable.isLoading = true;

			return RoomsNeedCleaning.getAll()
				.then((response) => {
					this.datatable.rows = response.data.data
				})
				.finally(() => {
					this.datatable.isLoading = false;
				});
		},


	}
}
</script>

